/* eslint-disable no-constant-condition */
/*global math, Algebrite, Element_Algebra, Element_Matrix*/ //Eslint declaration to prevent no-undef

import { styleSettings } from "../../../../../src/config/settings-features.mjs";
import { getEledaMessage } from "../../../lang/EledaMessages";
import { renderNumeric } from "./Utils-Html-Rendering.mjs";
import { isNumeric } from "../numeric/Utils-Numeric.mjs";
import { parseExpression } from "../numeric/Utils-Algebra.js";

/**
 * Test if object has inner function toTex() to be transformed in Latex, Element_Algebra ... (e.g mathjs object)
 * @param {*} object
 * @returns
 */
export function isConvertibleIntoLatex(object) {
  return (
    object != null &&
    (typeof object.toTex === "function" || typeof object.toLatex === "function")
  );
}

/**
 * Convert Latex's String to SVG withMathJax. tbd : implement parselatex as other library with lazy load but for the time being MathJax doesn't accept import('')
 * @param  {String} tex
 * @returns {DOM element}
 */
export function renderLatexIntoNode(tex, node) {
  console.log("renderLatexIntoNode", tex);
  let preamble = `
  \\definecolor{blue}{rgb}{${styleSettings.colorRGBLatex.blue}}  
  \\definecolor{purple}{rgb}{${styleSettings.colorRGBLatex.purple}} 
  \\definecolor{red}{rgb}{${styleSettings.colorRGBLatex.red}} 
  \\definecolor{yellow}{rgb}{${styleSettings.colorRGBLatex.yellow}}
  \\definecolor{green}{rgb}{${styleSettings.colorRGBLatex.green}} 
  \\definecolor{orange}{rgb}{${styleSettings.colorRGBLatex.orange}} 
  `;
  //The default math delimiters are $$...$$ and \[...\] for displayed mathematics
  //and \(...\) for in -line mathematics.Note in particular that the $...$
  node.appendChild(document.createTextNode("\\(" + preamble + tex + "\\)"));
}

export function convertObjectIntoLatex(object) {
  console.log("Utils-Latex - convertObjectIntoLatex", object);
  //MATHJS NODE / EXPRESSION
  let returnedObject = object;
  if (
    object === undefined ||
    object === null ||
    Number.isNaN(object) ||
    (([
      "number",
      "Complex",
      "BigNumber",
      "Fraction",
      "Unit",
      "Array",
      "Matrix",
    ].includes(math.typeOf(object)) ||
      object instanceof Element_Fraction) &&
      math.isNaN(object))
  ) {
    console.log(object + " is undefined or null");
    returnedObject = getEledaMessage("undefinedOrNull");
  } else if (object.isNode) {
    returnedObject = convertMathJSExpressionIntoLatex(object);
    console.log("Utils convertIntoNode math.js object", returnedObject);
  } else if (math.typeOf(object) == "Matrix") {
    returnedObject = math
      .parse(object.toString())
      .toTex(/* { parenthesis: true }*/);
    console.log(object, object.toString(), "is ", math.typeOf(object));
  } else if (Array.isArray(object)) {
    console.log("convertObjectIntoLatex Array", object);
    returnedObject = math
      .parse(math.matrix(object).toString()) //Don't use Array JS toString method because it generates w/o brackets.
      .toTex(/* { parenthesis: true }*/);
  } else if (object instanceof math.Fraction) {
    //math.Fraction or Element_Fraction
    returnedObject = object.toLatex(); //this function is a customOne defined in global-imports. The original latex generation on fraction object named toLateX which still exists
    console.log(
      object + " is a Fraction Fraction, constructor:",
      object.constructor.name
    );
  } else if (
    isNumeric(object) ||
    object instanceof Number ||
    object instanceof math.BigNumber
  ) {
    //return rendered numeric in locale (. for US decimals , , for FR decimals)
    returnedObject = renderNumeric(object); //this function is a customOne defined in global-imports. The original latex generation on fraction object named toLateX which still exists
    //because , add an extra space in latex put it into {}=> search for comma if any and replace by {,}
    returnedObject = returnedObject.replace(/,/g, "{$&}");
    console.log(object + " is a BigNumber");
  } else if (isConvertibleIntoLatex(object)) {
    //other mathjs objects or Eleda Object with toTex method
    returnedObject = object.toTex();
  }
  /*else if (typeof object == "string" || object instanceof String) {
      if (isMathParsableString(object)) {
        //works for 2*x... as well as equality f(x)=2*x
        returnedObject = convertMathJSExpressionIntoLatex(math.parse(object));
      }
    }*/

  return returnedObject;
}

/**
 *  Convert a MathJS expression into Algebrite Latex (better than mathjs. Natural human writing with the 2x and not 2\cdotx as mathjs does it)
 * We can use smartDisplay if no eledaAttributes are set on expression. In this case :
 * 1. Use the most explicit writint with mathjs to be understandable by Algebrite
 * 2. Use Algebrite with Algebrite.run(...) command (better than with JS Wrapper Algebrite.parse(...).toLatexString() or But Algebrite.run(..) reverse degree of polynom so use JS wrapper with default parenthesis to prevent to much parenthesis) to convert in a smart math writing style ( )
 * 3. Use mathjs again to not be too much explicit
 * Otherwise if eledaAttributes are used, simply pass parameters to mathjs
 *  * @param {*} expression MathJS Node object : expression, function : all math.js objects returned by math.parse('LLL...')
 * @returns
 */
export function convertMathJSExpressionIntoLatex(expression) {
  var smartDisplay = true;
  if (
    expression.eledaAttributes &&
    expression.eledaAttributes.smartDisplay === false
  ) {
    smartDisplay = false;
  }
  //let lateXResult = object.toTex({ implicit: "hide" });
  var expressionMembers;
  let lateXResult;
  //0. Because equality expression e.g f(x)=2*x are not managed by algebrite and mathjs (for mathjs = means affect value)
  //Thus split each equality expression if any, otherwise no effect take the expression as a whole
  if (smartDisplay) {
    expressionMembers = expression
      .toString({
        notation: "fixed",
        parenthesis: "all",
        implicit: "show",
      })
      .split("=");
    console.log(
      "convertMathJSExpressionIntoLatex expressionMembers:",
      expressionMembers
    );
    //1. Algebrite filter
    expressionMembers = expressionMembers.map((expMember) =>
      // Algebrite.run( "print("+...+")") reverse coeff order simply play run
      Algebrite.run(
        "" +
          expMember.toString({
            notation: "fixed",
            parenthesis: "all",
            implicit: "show",
          }) +
          ""
      )
    );
    console.log(
      "convertMathJSExpressionIntoLatex algebriteResultMembers:",
      expressionMembers
    );
    //2. MathJS filter
    expressionMembers = expressionMembers.map((expMember) =>
      parseExpression(expMember).toTex({
        implicit: "hide",
        parenthesis: "auto",
      })
    );
    console.log(
      "convertMathJSExpressionIntoLatex mathjsResultMembers:",
      expressionMembers
    );
    //Join equality members
    lateXResult = expressionMembers.join("=");
    lateXResult = localizeMultiplyChar(lateXResult, "~ ");
    lateXResult = replaceHalfPowerBySqrt(lateXResult);
  } else {
    expressionMembers = expression
      .toString({
        implicit: "show",
      })
      .split("=");
    let parenthesis;
    let implicit;
    console.log("expression.eledaAttributes.parenthesis");
    if (expression.eledaAttributes.parenthesis === "keep" || "auto" || "all") {
      parenthesis = expression.eledaAttributes.parenthesis;
    } else {
      parenthesis = "keep";
    }
    if (expression.eledaAttributes.implicit === "hide" || "show") {
      implicit = expression.eledaAttributes.implicit;
    } else {
      implicit = "hide";
    }
    expressionMembers = expressionMembers.map((expMember) =>
      parseExpression(expMember).toTex({
        parenthesis: parenthesis,
        implicit: implicit,
      })
    );
    console.log(
      "convertMathJSExpressionIntoLatex mathjsResultMembers:",
      expressionMembers
    );
    //Join equality members
    lateXResult = expressionMembers.join("=");
    lateXResult = localizeMultiplyChar(lateXResult, "\\times");
  }

  return lateXResult;

  /*lateXResult = Algebrite.run(
    "printlatex(" +
      expression.toString({
        notation: "fixed",
        implicit: "show",
        parenthesis: "all",
      }) +
      ")"
  );*/
  /*lateXResult = Algebrite.parse(
    expression.toString({
      notation: "fixed",
      implicit: "show",
    })
  ).toLatexString();

  console.log(
    "convertMathJSExpressionIntoLatex",
    expression.toString({
      notation: "fixed",
      implicit: "show",
    }),
    Algebrite.parse(
      expression.toString({
        notation: "fixed",
        implicit: "show",
      })
    ).toLatexString()
  );
  //If Algebrite fails to render mathjs expression, let's do it with mathjs
  if (lateXResult.includes("Stop: syntax error")) {
    lateXResult = expression.toTex({
      implicit: "hide",
    });
  }*/
}

// Fonction de remplacement
function replaceHalfPowerBySqrt(latexExpression) {
  // Expression régulière pour détecter les puissances de 1/2
  const regex = /{(.+?)}(\^{1\/2}|\^{1\/3}|\^{\\frac\{1\}\{2\}\})/gm;
  const returnLatexExpressionWithoutHalfPower = latexExpression.replace(
    regex,
    (match, variable) => {
      return `\\sqrt{${variable}}`;
    }
  );

  return returnLatexExpressionWithoutHalfPower;
}

/**
 * Replace cdot latex "•" by "x" to prevent confusion at math school level (more explicit for low levels ? to confirm by teachers)
 * Function could evolve by tzking into account language to let cdot or use another char.
 * @param {*} latex
 * @returns
 */
export function localizeMultiplyChar(latex, char) {
  let returnString = new String(latex);
  returnString = returnString.replaceAll("\\cdot", char);
  // returnString = returnString.replaceAll("\\cdot", "\\times");
  return returnString;
}

/*
import { mathjax } from "mathjax-full/js/mathjax";
import { TeX } from "mathjax-full/js/input/tex";
import { AllPackages } from "mathjax-full/js/input/tex/AllPackages";
import { SVG } from "mathjax-full/js/output/svg";

import { CHTML } from "mathjax-full/js/output/chtml";
import { browserAdaptor } from "mathjax-full/js/adaptors/browserAdaptor";
import { RegisterHTMLHandler } from "mathjax-full/js/handlers/html";
RegisterHTMLHandler(browserAdaptor());

const html = mathjax.document(document, {
  InputJax: new TeX({
    packages: AllPackages,
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"],
    ],
    chtml: {
      displayAlign: "left",
    },
  }),
  OutputJax: new CHTML({}),
});
window._MathJaxIsReady = true;

export function parseLatex(tex) {
  console.log("parseLatex");
  var returnNode = document.createElement("span");
  //The default math delimiters are $$...$$ and \[...\] for displayed mathematics
  //and \(...\) for in -line mathematics.Note in particular that the $...$

  let nodeMathJax = html.convert("\\[" + tex + "\\]");
  nodeMathJax.setAttribute("display", false);
  //let nodeMathJax = mathjax.tex2chtml(tex);

  console.log("nodeMathJax", nodeMathJax);
  returnNode.appendChild(nodeMathJax);
  //returnNode.innerHTML = nodeMathJax;
  
  html.updateDocument().reset();
  
  //html
    //.findMath()
  //  .compile()
  //  .typeset()
  //  .updateDocument()
  //  .reset();

  return returnNode;
}
*/

/*
//Old method  : Convert Latex's String to SVG withMathJax. tbd : implement parselatex as other library with lazy load but for the time being MathJax doesn't accept import('')
// Abandoned because of raceloading ≠ btw Chrome and FireFox
// here MathJax is generate Tex component by component
export function parseLatex(tex) {
  // TeX input

  //Code from DemoMathJax : 'https://github.com/mathjax/MathJax-demos-web/blob/master/input-tex2chtml.html.md'
  var returnNode = document.createElement("span");
  //  Reset the tex labels (and automatic equation numbers, though there aren't any here).
  //  Get the conversion options (metrics and display settings)
  //  Convert the input to CommonHTML output and use a promise to wait for it to be ready
  //    (in case an extension needs to be loaded dynamically).
  //
  //Check if MathJax is loaded to perform renderer.
  //Otherwiser, just append and the ready() function defined in index - node.js promise will do it.
    if (window._MathJaxIsReady) {
    MathJax.texReset();
    var options = MathJax.getMetricsFor(returnNode);
    options.display = false;
    MathJax.tex2chtmlPromise(tex, options)
      .then(function(node) {
        //
        //  The promise returns the typeset node, which we add to the output
        //  Then update the document to include the adjusted CSS for the
        //    content of the new equation.
        //
        returnNode.appendChild(node);
        MathJax.startup.document.clear();
        MathJax.startup.document.updateDocument();

        // console.log(returnNode);
      })
      .catch(function(err) {
        //
        //  If there was an error, put the message into the output instead
        //
        returnNode
          .appendChild(document.createElement("pre"))
          .appendChild(document.createTextNode(err.message));
      })
      .then(function() {});
  } else {
    returnNode.append(tex);
  }
  return returnNode; 

  // OLD VERSION : it works (don't forget to change the cdn call in activity.vue (from chtml to svg))
  // console.log('parseLatex'+tex)
  //console.log(window.MathJax.tex2svg(tex,{display: false}))
  //return window.MathJax.tex2svg(tex,{display: false})
}
*/
/**
 * Latter function could be transformed as following if necessary : this method works ! but to use it with Blockly, we should
 * change generated Blockly code with a new Element_Latex to have a getHtmlNode and have a inner node.
 */
/*export function parseLatex(node, tex){
  console.log('parseLatex')
  window.MathJax.tex2svgPromise(tex,{display: false}).then(function (nodeSVG) {
    node.append(nodeSVG)
    //MathJax.startup.document.clear();
    //MathJax.startup.document.updateDocument();
  }).catch(function(err) {
    node.append('Impossible to generate TeX')
  })
}
*/

//Mis en commentaire car remplacé par JSXGraph
// export function plotPlotly(node, data, layout, config) {
//   console.log('plotlyPlot')

//   //WebPack comments : to guarantee that showdown package is accessible from its chunk.js we set his name to 'showndown.[id].js'
//   import(
//   /* webpackChunkName: "plotly.js-basic-dist" */
//   /* webpackMode: "lazy" */
//   /* webpackExports: ["default", "named"] */
//   'plotly.js-basic-dist').then(({default : Plotly}) => {
//      console.log('Lib Plotly loaded')
//   //  window.PlotlyConfig = {MathJaxConfig: 'local'}
//     Plotly.newPlot(node, data, layout, config)
//   }).catch(error => {
//     console.log(error)
//     node.append('Impossible to load Plotly lib or generate Plot')
//   })

// }
/**
 * NO MORE USED : Convert Latex Frac into simple Math.js simple Fraction
 * @param  {String} latexString
 * @returns {math.Fraction}
 */
/* 
export function convertLatexIntoFraction(latex) {
  while (latex.search(/\\frac\{(((?![\{\}]).)*)\}\{(((?![\{\}]).)*)\}/) >= 0) {
    latex = latex.replace(
      /\\frac\{(((?![\{\}]).)*)\}\{(((?![\{\}]).)*)\}/g,
      "$1/$3"
    );
  }
  return new math.Fraction(latex);
}*/

/**
 * Convert Matrix and Array to LatTex String then to HTMLDOM by using parserLatex()
 * @param  {Array} matrix
 * @returns {DOM element}
 */
/*
export function convertMatrixIntoLatex(matrix) {
  const size = matrix.size(); // return array os size [2 rows,3 columns]
  console.log("convertMatrixIntoLatex matrix.length", matrix.length);
  var matrixLatex = "\\begin{pmatrix}" + "\n";
  for (let i = 0; i < size[0]; i++) {
    for (let j = 0; j < size[1]; j++) {
      //Test if object is itself another element to display in Latex
      var object = matrix[i][j];
      if (math.typeOf(object) == "Fraction") {
        object =
          "\\Large \\frac{ " + object.s * object.n + "}{ " + object.d + "}";
      }
      matrixLatex += "\t" + object;
      if (j < matrix[i].length - 1) {
        matrixLatex += " & ";
      }
      if (j == matrix[i].length - 1 && i < matrix.length - 1) {
        matrixLatex += " \\\\" + "\n";
      }
      if (j == matrix[i].length - 1 && i == matrix.length - 1) {
        matrixLatex += "\n";
      }
    }
  }
  matrixLatex += "\\end{pmatrix}";
  console.log("matrixLatex", matrixLatex);
  return matrixLatex;
}
*/
